<template>
  <div>
    <form :action="action" :method="method" dusk="checkout_register_form">

      <!-- Personal Data -->
      <spacer></spacer>
      <div class="row justify-content-center align-items-top px-2 px-md-0">
        <div class="col-12">
          <div class="container-fluid">
            <h4 class="register-h4 mb-4">{{$t('vue.checkout.pages.fromRegister.personalities')}}</h4>

            <!-- Salutation -->
            <div class="form-group" id="salutation">
              <p><strong>{{$t('vue.checkout.pages.fromRegister.salutation')}}</strong></p>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="consumer[salutation]"
                       id="field_salutationMr"
                       value="MR" v-model="fields.salutation.value">
                <label class="form-check-label" for="field_salutationMr">{{ $t('general.male') }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="consumer[salutation]"
                       id="field_salutationMs" v-model="fields.salutation.value"
                       value="MS">
                <label class="form-check-label" for="field_salutationMs">{{$t('general.female')}}</label>
              </div>
            </div>

            <!-- Name -->

            <div class="form-row">
              <div class="col-11 col-md-4 form-group">
                <label for="fields_first_name">{{$t('general.firstName')}}</label>
                <input required type="text" name="consumer[first_name]" id="fields_first_name"
                       dusk="first_name"
                       class="form-control"
                       :class="getValidationClass(fields.first_name.valid)"
                       :placeholder="$t('general.firstName')"
                       @change="validateFirstName"
                       v-model="fields.first_name.value">
                <div class="invalid-feedback">
                  {{ fields.first_name.error }}
                </div>
              </div>
              <div class="col-11 col-md-4 form-group">
                <label for="fields_last_name">{{ $t('general.lastName') }}</label>
                <input required type="text" name="consumer[last_name]" id="fields_last_name"
                       dusk="last_name"
                       class="form-control"
                       :class="getValidationClass(fields.last_name.valid)"
                       :placeholder="$t('general.lastName')"
                       @change="validateLastName"
                       v-model="fields.last_name.value">
                <div class="invalid-feedback">
                  {{ fields.last_name.error }}
                </div>
              </div>
            </div>
            <!-- Birthday -->
            <div class="form-row">
              <div class="col-12">
                <strong>{{ $t('general.dateOfBirth') }}</strong>
              </div>

              <div class="form-group col-3 col-md-2 mb-0">
                <input type="number"
                       pattern="[0-9]*"
                       name="consumer[birthday]"
                       id="birthday"
                       dusk="birthday"
                       maxlength="2"
                       placeholder="01"
                       max="31"
                       min="1"
                       @keyup="toMonth"
                       @change="validateDay(); validateBirthday()"
                       class="form-control register-birth birth-day text-center"
                       :class="getValidationClass(fields.birthday.day.valid)"
                       v-model="fields.birthday.day.value">
              </div>

              <div class="my-auto">
                .
              </div>

              <div class="form-group col-3 col-md-2 mb-0">
                <input type="number"
                       pattern="[0-9]*"
                       name="consumer[birthmonth]"
                       id="birthmonth"
                       dusk="birthmonth"
                       maxlength="2"
                       placeholder="01"
                       max="12"
                       min="1"
                       @keyup="toYear"
                       @change="validateMonth(); validateBirthday()"
                       class="form-control register-birth birth-month text-center"
                       :class="getValidationClass(fields.birthday.month.valid)"
                       v-model="fields.birthday.month.value">
              </div>

              <div class="my-auto">
                .
              </div>

              <div class="form-group col-4 col-md-2 mb-0">
                <input required
                       type="number"
                       pattern="[0-9]*"
                       name="consumer[birthyear]"
                       id="birthyear"
                       dusk="birthyear"
                       maxlength="4"
                       placeholder="1960"
                       min="1900"
                       :max="youngestYear"
                       @keyup="toAddress"
                       @change="validateYear(); validateBirthday()"
                       class="form-control register-birth text-center"
                       :class="getValidationClass(fields.birthday.valid)"
                       v-model="fields.birthday.year.value">
              </div>
              <div class="col-md-4 col-4 d-flex align-items-center">
                <small>{{$t('vue.checkout.pages.fromRegister.exampleDate')}}</small>
              </div>

            </div>
            <div v-if="fields.birthday.valid === -1">
              <p class="text-danger mt-1 small">
                {{ fields.birthday.error }}
              </p>
            </div>
            <div v-if="fields.birthday.day.valid === -1">
              <p class="text-danger mt-1 small">
                {{$t('vue.checkout.pages.fromRegister.day')}}: {{ fields.birthday.day.error }}
              </p>
            </div>
            <div v-if="fields.birthday.month.valid === -1">
              <p class="text-danger mt-1 small">
                {{$t('vue.checkout.pages.fromRegister.month')}}: {{ fields.birthday.month.error }}
              </p>
            </div>
            <!--
            <div v-if="fields.birthday.year.valid === -1">
              <p class="text-danger mt-1 small">
                Jahr: {{ fields.birthday.year.error }}
              </p>
            </div>
            -->
          </div>
        </div>
      </div>

      <spacer></spacer>

      <!-- Address -->
      <div class="row justify-content-center align-items-top">
        <div class="col-12">
          <div class="container-fluid">
            <h4 class="register-h4 mb-4">{{$t('vue.checkout.pages.fromRegister.yourBillingAddress')}}</h4>

            <div class="form-row">
              <div class="col-12 col-md-7 form-group mb-0">
                <label for="fields_street">{{ $t('general.addressAndNumber') }}</label>
                <input required type="text"
                       dusk="street"
                       id="fields_street"
                       class="form-control"
                       name="address[street]"
                       :class="getValidationClass(fields.street.valid)"
                       :placeholder="$t('general.addressNumber')"
                       @change="validateStreet"
                       v-model="fields.street.value">
                <div class="invalid-feedback">
                  {{ fields.street.error }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div id="addressBlock" class="col-12 col-md-7">
                <!--
                <address-line
                        v-on:newAddressLine="addAddressLine"
                        :given-lines="fields.addressLines.values"
                        field-name="address[additional]"
                        v-on:removeAddressLine="removeAddressLine"
                ></address-line>
                -->
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-12 col-md-4 form-group">
                <label for="fields_postal_code">{{ $t('general.postcode') }}</label>
                <input required
                       type="number"
                       pattern="[0-9]*"
                       name="address[postal_code]"
                       dusk="plz"
                       id="fields_postal_code"
                       maxlength="4"
                       class="form-control"
                       :class="getValidationClass(fields.postalCode.valid)"
                       :placeholder="$t('general.postcodeShort')"
                       @change="validatePostalCode"
                       v-model="fields.postalCode.value">
                <div class="invalid-feedback">
                  {{ fields.postalCode.error }}
                </div>
              </div>
              <div class="col-12 col-md-3 form-group">
                <label for="fields_city">{{$t('general.place')}}</label>
                <input required type="text" name="address[city]" id="fields_city"
                       dusk="city"
                       class="form-control"
                       :class="getValidationClass(fields.city.valid)"
                       :placeholder="$t('general.placeCity')"
                       @change="validateCity"
                       v-model="fields.city.value">
                <div class="invalid-feedback">
                  {{ fields.city.error }}
                </div>
              </div>
            </div>

            <div class="form-row mt-2 text-danger" v-if="showPostalCodeHint">
              <div class="col-7">
                <div class="d-flex border border-danger">
                  <div class="align-self-center pl-2 pr-2">
                    <i class="fa fa-times-circle"></i>
                  </div>
                  <div>
                    {{ $t('vue.checkout.pages.fromRegister.postalCodeNote') }}
                      <a :href="$t('vue.checkout.pages.fromRegister.backToPageLink')" class="text-underline">{{ $t('vue.checkout.pages.fromRegister.backToPage') }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <spacer></spacer>

      <!-- E-Mail + Tel -->
      <div class="row justify-content-center align-items-top">
        <div class="col-12">
          <div class="container-fluid">

            <h4 class="register-h4 mb-3">{{$t('vue.checkout.pages.fromRegister.howToReachYou')}}</h4>

            <div class="form-row">
              <div class="col-12">
                <label for="field_email">{{$t('general.emailAddress')}}</label>
              </div>
              <div class="col-11 col-md-4 form-group">
                <input required
                       v-model="fields.email.value"
                       dusk="email"
                       type="email"
                       name="consumer[email]"
                       id="field_email"
                       class="form-control"
                       :class="getValidationClass(fields.email.valid)"
                       :placeholder="$t('vue.checkout.pages.fromRegister.exampleEmail')"
                       @change="validateEmail(), checkIfMailAlreadyExists()"
                >
                <div class="invalid-feedback">
                  {{ fields.email.error }}
                </div>
              </div>
              <div class="col-12 col-md-8 d-flex align-items-center">

              </div>


              <div class="col-12">
                <label for="field_telephone">{{$t('vue.checkout.pages.fromRegister.numberTelefon')}}</label>
              </div>
              <div class="col-11 col-md-4 form-group">
                <input required
                       type="tel"
                       dusk="tel"
                       name="consumer[telephone]"
                       id="field_telephone"
                       class="form-control"
                       :class="getValidationClass(fields.tel.valid)"
                       placeholder="079/1111111"
                       @change="validateTel"
                       v-model="fields.tel.value"
                >
                <div class="invalid-feedback">
                  {{ fields.tel.error }}
                </div>
              </div>
              <div class="col-12 col-md-8 d-flex align-items-center">
                <form-hint
                    :text="$t('vue.checkout.pages.fromRegister.infoNumberTelefon')"/>
              </div>

            </div>
          </div>
        </div>
      </div>

      <spacer></spacer>

      <!-- Password -->
      <div class="row justify-content-center align-items-top">
        <div class="col-12">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <h4 class="register-h4 mb-3">{{ $t('vue.checkout.pages.fromRegister.yourProfile') }}</h4>

                <form-hint
                    :text="$t('vue.checkout.pages.fromRegister.infoProfile')"/>
              </div>

              <div class="col-11 col-md-12">
                <password-field v-on:password-is-invalid="setPasswordAsInvalid"
                                v-on:password-is-valid="setPasswordAsValid"
                                v-on:update:password="fields.password.value = $event"
                                v-on:update:passwordConfirmation="fields.password.success = $event"
                                :label="$t('vue.checkout.pages.fromRegister.password')"
                                :id="'password'"
                                name="'consumer[password]'"
                ></password-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" v-model="fields.country.value" name="address[country]">

      <div class="row mt-5">
        <div class="col-12 text-center">
          <button type="submit"
                  name="submit"
                  class="btn btn-primary px-5" v-if="formValid">{{$t('vue.checkout.pages.fromRegister.continueToPayment')}}
          </button>
          <button type="submit"
                  name="submit-disabled"
                  class="btn btn-primary px-5" disabled v-else>{{$t('vue.checkout.pages.fromRegister.continueToPayment')}}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import PNotify from 'pnotify/dist/es/PNotify';

PNotify.defaults.styling = 'bootstrap4';
PNotify.defaults.icons = 'fontawesome5';


export default {
  name: "FormRegister",
  props: {
    action: String,
    method: String,
    csrfToken: String,
    minimumAge: {
      type: Object,
      required: true
    },
    defaultCountry: {
      type: String,
      default: "germany"
    }
  },
  data () {
    return {
      nationalities: window.nationalities,
      firstIteration: true,
      loading: false,
      showPostalCodeHint: false,
      fields: {
        salutation: {
          value: "MR",
          valid: 1,
          error: "",
          success: ""
        },
        first_name: {
          value: "",
          valid: 0,
          error: "Bitte richtig ausfüllen",
          success: ""
        },
        last_name: {
          value: "",
          valid: 0,
          error: "Bitte richtig ausfüllen",
          success: ""
        },
        birthday: {
          day: {
            value: "",
            valid: 0,
            error: this.$t('vue.checkout.pages.fromRegister.numberBtw1-31'),
            success: ""
          },
          month: {
            value: "",
            valid: 0,
            error: this.$t('vue.checkout.pages.fromRegister.numberBtw1-12'),
            success: ""
          },
          year: {
            value: "",
            valid: 0,
            error: "Bitte eine gültige Jahreszahl eintragen.",
            success: ""
          },
          valid: 0,
          error: this.$t('vue.checkout.pages.fromRegister.minAgeRequirement', {age: this.minimumAge.min_age}),
          success: ""
        },
        street: {
          value: "",
          valid: 0,
          error: "",
          success: ""
        },
        postalCode: {
          value: "",
          valid: 0,
          error: "",
          success: ""
        },
        city: {
          value: "",
          valid: 0,
          error: "",
          success: ""
        },
        addressLines: {
          values: [],
          valid: 0,
          error: "",
          success: ""
        },
        country: {
          value: "ch",
          valid: 0,
          error: "",
          success: ""
        },
        email: {
            value: "",
            valid: 0,
            error: this.$t('vue.checkout.pages.fromRegister.validEmail'),
            success: ""
        },
          tel: {
              value: "",
              valid: 0,
              error: this.$t('vue.checkout.pages.fromRegister.validNumberTeefon'),
              success: ""
          },
          password: {
          value: "",
          valid: 0,
          error: "",
          success: ""
        }
      }
    }
  },
  methods: {
    toMonth () {
      if (this.fields.birthday.day.value.length === 2) {
        const monthField = document.getElementById ('birthmonth');
        monthField.focus ();
      }
    },
    toYear () {
      if (this.fields.birthday.month.value.length === 2) {
        const yearField = document.getElementById ('birthyear');
        yearField.focus ();
      }
    },
    toAddress () {
      if (this.fields.birthday.year.value.length === 4) {
        const streetField = document.getElementById ('fields_street');
        streetField.focus ();
      }
    },
    validateFirstName () {
      let first_name = this.fields.first_name.value;
      if (first_name.length > 0) {
        let re = /^[A-Za-z\u00C0-\u017F\s\-]+$/;
        let valid = re.test (first_name);
        this.fields.first_name.valid = valid ? 1 : -1;
      } else {
        this.fields.first_name.valid = 0;
      }
    },
    validateLastName () {
      let last_name = this.fields.last_name.value;
      if (last_name.length > 0) {
        let re = /^[A-Za-z\u00C0-\u017F\s\-]+$/;
        let valid = re.test (last_name);
        this.fields.last_name.valid = valid ? 1 : -1;
      } else {
        this.fields.last_name.valid = 0;
      }
    },
    validateBirthday () {
      let day = this.fields.birthday.day.value;
      let month = this.fields.birthday.month.value;
      let year = this.fields.birthday.year.value;

      if (day.length > 0 && month.length > 0 && year.length > 0) {
        let today = new Date ()
        let givenDate = new Date (parseInt (year), parseInt (month) - 1, day);
        let latestDayInPast = new Date (
            new Date ().setFullYear (today.getFullYear () - this.minimumAge.min_age)
        )
        this.fields.birthday.valid = givenDate <= latestDayInPast ? 1 : -1;
      } else {
        this.fields.birthday.valid = 0;
      }
    },
    validateDay () {
      let day = this.fields.birthday.day.value;
      if (day.length > 0) {
        this.fields.birthday.day.valid = day > 0 && day <= 31 ? 1 : -1;
      } else {
        this.fields.birthday.day.valid = 0;
      }
    },
    validateMonth () {
      let month = this.fields.birthday.month.value;
      if (month.length > 0) {
        this.fields.birthday.month.valid = month > 0 && month <= 12 ? 1 : -1;
      } else {
        this.fields.birthday.month.valid = 0;
      }
    },
    validateYear () {
      let year = this.fields.birthday.year.value;
      if (year.length > 0) {
        this.fields.birthday.year.valid = year >= 1900 && year <= this.youngestYear ? 1 : -1;
      } else {
        this.fields.birthday.year.valid = 0;
      }
    },
    validateStreet () {
      let street = this.fields.street.value;
      if (street.length > 0) {
        let re = /^\d+$/;
        let invalid = re.test (street); // Contains numbers only
        this.fields.street.valid = invalid ? -1 : 1;
      } else {
        this.fields.street.valid = 0;
      }
    },
    validatePostalCode () {
      let plz = this.fields.postalCode.value;
      this.showPostalCodeHint = false;

      // postal codes from lichtenstein
      const notAllowed = [9485, 9486, 9487, 9488, 9489, 9490, 9491, 9492, 9493, 9494, 9495, 9496, 9497, 9498];

      if (plz.length === 0) {
        this.fields.postalCode.valid = 0;
      } else if (notAllowed.includes(parseInt(plz))) {
          this.fields.postalCode.valid = -1;
          this.showPostalCodeHint = true;
      } else if (plz.length > 4) {
        this.fields.postalCode.valid = -1;
      } else {
        let re = /\b\d{4,5}(?:-\d{4})?\b/;
        let valid = re.test (plz);
        this.fields.postalCode.valid = valid ? 1 : -1;
      }
    },
    validateCity () {
      let city = this.fields.city.value;
      if (city.length > 0) {
        let re = /^[A-Za-z\u00C0-\u017F ]+$/;
        let valid = re.test (city);
        this.fields.city.valid = valid ? 1 : -1;
      } else {
        this.fields.city.valid = 0;
      }
    },
    validateEmail () {
      let email = this.fields.email.value;
      if (email.length > 0) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let valid = re.test (email);
        this.fields.email.valid = valid ? 1 : -1;
      } else {
        this.fields.email.valid = 0;
      }
    },
    checkIfMailAlreadyExists () {
      let self = this;
      axios.post ('/api/validators/email-available', {
        email: this.fields.email.value
      }).then (result => {
        console.log (result);
        self.fields.email.valid = result.data.status === 'valid' ? 1 : -1;
          if (result.data.status === 'invalid') {
              if (result.data.message === 'E-Mail-Adresse ist schon vergeben.') {
                  self.fields.email.error = this.$t('emailAlreadyTaken')
              }
              /* self.fields.email.error = result.data.message; */
              else {
                  self.fields.email.error = this.$t('vue.checkout.pages.fromRegister.validEmail')
              }
          }
      });
    },
    validateTel () {
      let tel = this.fields.tel.value;
      if (tel.length > 0) {
        let re = /^[+]?[0-9//-\s]+/;
        let valid = re.test (tel);
        this.fields.tel.valid = valid ? 1 : -1;
      } else {
        this.fields.tel.valid = 0;
      }
    },
    getValidationClass (valid) {
      // valid could be -1,0,1
      let className = '';
      switch (valid) {
        case -1:
          className = 'is-invalid';
          break;
        case 1:
          className = 'is-valid';
          break;
        default:
          className = '';
          break;
      }
      return className;
    },
    validateOnMounted () {
    },
    validateOnSubmit () {
    },
    addAddressLine: function (payload) {
      this.fields.addressLines.values[payload.id] = payload.value;
    },
    removeAddressLine: function (payload) {
      this.fields.addressLines.values.splice (payload, 1);
    },
    setPasswordAsValid: function () {
      this.fields.password.valid = 1;
    },
    setPasswordAsInvalid: function () {
      this.fields.password.valid = -1;
    },
  },
  computed: {
    youngestYear () {
      let year = new Date ().getFullYear ();
      return year - this.minimumAge.min_age;
    },
    formValid () {
      let total = 0;
      this.fields.salutation.valid === 1 ? total += 1 : total += 0;
      this.fields.first_name.valid === 1 ? total += 1 : total += 0;
      this.fields.last_name.valid === 1 ? total += 1 : total += 0;
      this.fields.birthday.day.valid === 1 ? total += 1 : total += 0;
      this.fields.birthday.month.valid === 1 ? total += 1 : total += 0;
      this.fields.birthday.year.valid === 1 ? total += 1 : total += 0;
      this.fields.street.valid === 1 ? total += 1 : total += 0;
      this.fields.postalCode.valid === 1 ? total += 1 : total += 0;
      this.fields.city.valid === 1 ? total += 1 : total += 0;
      this.fields.email.valid === 1 ? total += 1 : total += 0;
      this.fields.tel.valid === 1 ? total += 1 : total += 0;
      this.fields.password.valid === 1 ? total += 1 : total += 0;

      return total === 12;
    },
    progress () {
      let progress = 0;
      this.fields.salutation.valid === 1 ? progress += 5 : progress += 0;
      this.fields.first_name.valid === 1 ? progress += 5 : progress += 0;
      this.fields.last_name.valid === 1 ? progress += 5 : progress += 0;
      this.fields.birthday.day.valid === 1 ? progress += 5 : progress += 0;
      this.fields.birthday.month.valid === 1 ? progress += 5 : progress += 0;
      this.fields.birthday.year.valid === 1 ? progress += 5 : progress += 0;
      this.fields.street.valid === 1 ? progress += 5 : progress += 0;
      this.fields.postalCode.valid === 1 ? progress += 5 : progress += 0;
      this.fields.city.valid === 1 ? progress += 5 : progress += 0;
      this.fields.email.valid === 1 ? progress += 5 : progress += 0;
      this.fields.tel.valid === 1 ? progress += 5 : progress += 0;
      this.fields.password.valid === 1 ? progress += 5 : progress += 0;

      return progress + "%";
    }
  },
  watch: {
    defaultCountry (newValue, oldValue) {
      if (newValue != oldValue) {
        this.fields.country.value = newValue
      }
    },
    fields: {
      handler (value1, value2) {
        // had to reset this value because when coming back from payment page, the first_name input field
        // is the only pre-populated field
        // sorry i had to do it quick and dirty because i had to switch to genesis
        if (this.firstIteration && this.fields.first_name.value.length > 1) {
          this.fields.first_name.value = ''
          this.fields.first_name.valid = 0
          this.firstIteration = false
        }
        this.$emit ('form-updated', this.progress);
      },
      deep: true
    }
  },
  mounted () {
    this.fields.first_name.value = ''
    this.fields.first_name.valid = 0
    this.fields.country.value = this.defaultCountry
  }
}
</script>

<style lang="scss" scoped>
.form-control {
  &.register-birth {
    &.birth-day {
      background-image: none;
    }

    &.birth-month {
      background-image: none;
    }
  }
}
   /* Chrome, Safari, Edge, Opera */
   input::-webkit-outer-spin-button,
   input::-webkit-inner-spin-button {
     -webkit-appearance: none;
     margin: 0;
   }

   /* Firefox */
   input[type=number] {
     -moz-appearance: textfield;
   }

   .flex-1 {
     flex: 1;
   }

   .flex-8 {
     flex: 8;
   }
</style>
